import { IObject } from "@entities/api/object";
import { IUpdateObject } from "@entities/object";
import { uuidRegex } from "@shared/utils";
import { FormType } from "../../../types/form-type";

/*
 * Случаи
 * 1. Документ новый {key: string, ...metaData}
 * 2. Документ обновляется {key: string, ...metaData}
 * 3. Документ остается {key: null}
 * 4. Документ удаляется null
 * */
export function getDocumentationPermissions(
  data: FormType,
  orig: IObject,
): [IUpdateObject["documentationPermissions"], File[] | undefined] | undefined {
  // удаляем все разрешения, если выбрано "не требуется"
  if (!data.permissions?.required) {
    return [
      // @ts-expect-error optionals
      orig.documentationPermissions.map((p) => ({
        documentationPermissionId: p.documentationPermissionId,
      })),
      undefined,
    ];
  }

  if (data.permissions.documentationPermissions) {
    const permissionFiles = [] as { file?: File | null; uid: string }[];

    const documentationPermissions =
      data.permissions.documentationPermissions.map((p) => {
        if (p.file?.id && !uuidRegex.test(p.file?.id)) {
          permissionFiles.push({
            uid: p.file.id,
            file: p.file.file,
          });
        }

        // в остальных случаях удаляем
        let file = null;
        // если id - uuid, сохраняем файл
        if (uuidRegex.test(p.file?.id ?? "")) {
          file = {
            key: null,
          };
          // если id - автоматически сгенерированный библиотекой ant, сохраняем.
        } else if (p.file?.id) {
          file = {
            key: p.file.id,
            fileName: p.file.file?.name,
            fileType: p.file.file?.type,
            fileContentLength: p.file.file?.size,
          };
        }

        // если блок новый - null, если уже существующий - отправляем существующий id.
        return {
          documentationPermissionId: p.documentationPermissionId ?? null,
          number: p.number,
          issued: p.issued,
          date: p.date.toISOString(),
          expiryDate: p.expiryDate?.toISOString(),
          prolongDate: p.prolongDate?.toISOString(),
          permissionFile: {
            file,
            // WAIT: на время убираем подписи
            signature: null,
          },
        };
      });

    // Append deletions captured in form state (deletedPermissions Set)
    if (data.deletedPermissions && data.deletedPermissions.size > 0) {
      const idsToDelete = Array.from(data.deletedPermissions);
      idsToDelete.forEach((id) => {
        const stillPresent = data.permissions?.documentationPermissions?.some(
          (p) => p.documentationPermissionId === id,
        );
        if (!stillPresent) {
          // @ts-expect-error partials allowed by backend for deletions
          documentationPermissions.push({
            documentationPermissionId: id,
          });
        }
      });
    }

    // @ts-expect-error types
    return [documentationPermissions, permissionFiles] as [
      typeof documentationPermissions,
      typeof permissionFiles,
    ];
  }
}
